export default __webpack_public_path__ + "static/media/slide_3.5cbfc9ad.jpg";